import { IPropertyFilter } from './IPropertyFilter'
import { ISearch } from './ISearch'

export interface IFilterSet<T> {
  appliedCount: number
  normalizedFilters: string[]
  orderBy: string
  filters: Record<string, IPropertyFilter<T>>
  search?: ISearch<T>
}

export enum FilterIdList {
  SalesFunnelId = 'salesFunnelId',
  SalesFunnelStageId = 'salesFunnelStageId',
}
